import { useSite } from "@/context/SiteContext";
import { PageHero } from "@/components/Shared";
import { IMAGES } from "@/lib/images";
import { MessageCircle, Phone, MapPin, Clock, Facebook, Instagram, Send } from "lucide-react";

export default function Contatti() {
  const { settings } = useSite();
  const wa = settings.whatsapp || "393331512490";
  const waLink = `https://wa.me/${wa}?text=${encodeURIComponent("Salve, vorrei informazioni riservate riguardo Afrodite Club Privé e Spa.")}`;

  return (
    <div>
      <PageHero
        overline="Prenota la tua Serata"
        title="Contatti"
        subtitle="Nessun form online: per informazioni e prenotazioni scrivici su WhatsApp o chiamaci direttamente."
        image={IMAGES.spa_amb}
      />

      <section className="max-w-4xl mx-auto px-6 py-20">
        {settings.announcement && (
          <div className="mb-12 p-5 rounded-xl border border-[#D4AF37]/25 bg-[#141217] text-center">
            <p className="text-sm text-[#F3E5AB] leading-relaxed">{settings.announcement}</p>
          </div>
        )}

        <div className="grid gap-5 sm:grid-cols-2 mb-12">
          <a data-testid="contact-whatsapp" href={waLink} target="_blank" rel="noopener noreferrer"
            className="group p-8 rounded-2xl border border-[#25D366]/30 bg-[#141217] hover:border-[#25D366] transition-all duration-500 text-center">
            <div className="w-14 h-14 mx-auto rounded-full bg-[#25D366]/15 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
              <MessageCircle className="w-6 h-6 text-[#25D366]" />
            </div>
            <h3 className="font-display text-xl text-[#FBF8F5] mb-1">WhatsApp Riservato</h3>
            <p className="text-sm text-[#A39E9B]">Scrivici per informazioni discrete</p>
          </a>

          <a data-testid="contact-call" href={`tel:+39${(settings.phone || "3331512490").replace(/\s/g, "")}`}
            className="group p-8 rounded-2xl border border-[#7A1426]/40 bg-[#141217] hover:border-[#D4AF37]/50 transition-all duration-500 text-center">
            <div className="w-14 h-14 mx-auto rounded-full bg-[#7A1426]/25 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
              <Phone className="w-6 h-6 text-[#D4AF37]" />
            </div>
            <h3 className="font-display text-xl text-[#FBF8F5] mb-1">Chiama Ora</h3>
            <p className="text-sm text-[#D4AF37]">{settings.phone || "333 1512490"}</p>
          </a>
        </div>

        <div className="grid gap-4 sm:grid-cols-3 text-center">
          <div className="p-6 rounded-xl border border-[#D4AF37]/12 bg-[#141217]">
            <MapPin className="w-5 h-5 text-[#D4AF37] mx-auto mb-3" />
            <p className="text-xs text-[#6E6865] uppercase tracking-widest mb-1">Dove Siamo</p>
            <p className="text-sm text-[#A39E9B]">{settings.address || "Puglia"}</p>
          </div>
          <div className="p-6 rounded-xl border border-[#D4AF37]/12 bg-[#141217]">
            <Clock className="w-5 h-5 text-[#D4AF37] mx-auto mb-3" />
            <p className="text-xs text-[#6E6865] uppercase tracking-widest mb-1">Orari</p>
            <p className="text-sm text-[#A39E9B]">{settings.opening_hours}</p>
          </div>
          <div className="p-6 rounded-xl border border-[#D4AF37]/12 bg-[#141217]">
            <Instagram className="w-5 h-5 text-[#D4AF37] mx-auto mb-3" />
            <p className="text-xs text-[#6E6865] uppercase tracking-widest mb-1">Social</p>
            <div className="flex flex-col gap-1">
              {settings.instagram_url && (
                <a href={settings.instagram_url} target="_blank" rel="noopener noreferrer" data-testid="contact-instagram-1"
                  className="text-sm text-[#D4AF37] hover:text-[#F3E5AB]">@{settings.instagram_url.replace(/\/$/, "").split("/").pop()}</a>
              )}
              {settings.telegram && (
                <a href={`https://t.me/+${settings.telegram}`} target="_blank" rel="noopener noreferrer" data-testid="contact-telegram"
                  className="text-sm text-[#D4AF37] hover:text-[#F3E5AB] inline-flex items-center gap-1 justify-center"><Send className="w-3.5 h-3.5" /> Telegram</a>
              )}
              {settings.facebook_url && <a href={settings.facebook_url} target="_blank" rel="noopener noreferrer" className="text-sm text-[#D4AF37] hover:text-[#F3E5AB] inline-flex items-center gap-1 justify-center"><Facebook className="w-3.5 h-3.5" /> Facebook</a>}
              {!settings.instagram_url && !settings.facebook_url && <p className="text-sm text-[#A39E9B]">Presto disponibile</p>}
            </div>
          </div>
        </div>

        <div className="mt-12 rounded-2xl overflow-hidden border border-[#D4AF37]/20" data-testid="contact-map">
          <iframe title="Mappa Afrodite Club" loading="lazy" className="w-full h-72 sm:h-96 grayscale-[0.4] contrast-[1.1]"
            src={`https://www.google.com/maps?q=${encodeURIComponent(settings.address || "Via Terlizzi, Molfetta (BA)")}&output=embed`} />
        </div>
      </section>
    </div>
  );
}
